<app-dropdown-option>
  <svg-icon [stretch]="true" [src]="'clear-form'"></svg-icon>
  {{ text }}
</app-dropdown-option>
